import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

import { Course } from "./../../shared/models/course";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-courses",
  templateUrl: "./courses.component.html",
})
export class CoursesComponent implements OnInit, OnDestroy {
  courseList: Course[];
  showNoCourseMessage = false;
  private destroy$ = new Subject<void>();

  @Input() courses: BehaviorSubject<Course[]>;
  @Input() ccpAudit: boolean;
  @Output() courseDeleted: EventEmitter<string> = new EventEmitter();

  ngOnInit() {
    this.courses.pipe(takeUntil(this.destroy$)).subscribe((c) => {
      if (!c || c.length === 0) {
        this.showNoCourseMessage = true;
      } else {
        this.showNoCourseMessage = false;
      }

      this.courseList = c;
    });
  }

  deleteCourse(courseId: string) {
    this.courseDeleted.emit(courseId);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
